/*
@function calculateWhatsImportantScore
@param {Object} listing
@param {String} filterValue
*/
function calculateWhatsImportantScore(listing, filterValue) {
    var weight = 0.75;
    var value = 0;
    var threshold = 3;
    var metWhyWhyNotThreshold;

    if(filterValue === 'walkability') {
        value = listing.reports.area.score / 10;
    } else if(filterValue === 'restaurants') {
        value = listing.reports.restaurant.score / 10;
    } else if(filterValue === 'outdoors') {
        value = listing.reports.outdoors.score / 10;
    }

    if((value * weight) >= 7) {
        metWhyWhyNotThreshold = true;
    } else if((value * weight) <= 3) {
        metWhyWhyNotThreshold = false;
    } else {
        metWhyWhyNotThreshold = 'neutral';
    }

    return {
        weight: weight,
        value: value,
        score: value * weight,
        metThreshold: (value * weight) >= threshold,
        metWhyWhyNotThreshold: metWhyWhyNotThreshold
    };
}

module.exports = calculateWhatsImportantScore;
